
import { useMemo } from "react";
import Resident from "../../Residents/Models/Resident";
import { PreCertTable } from "../../Shared/Components/PreCertTable";
import { getDateWithOffset } from "../../Shared/Utility/GetDateWithOffset";
import { TrainingAttestation } from "../Models/TrainingAttestation";

interface IProps {
    trainingProgramId: number;
    residency: Resident;
}

export default function TrainingAttestationGrid(props: IProps) {
    const trainingAttestationColumns = useMemo(
        () => [
            {
                Header: "Program",
                width: "auto",
                accessor: (a: TrainingAttestation) => `(${a.trainingProgramCode}) ${a.trainingProgramName}`
            },
            {
                Header: "Certification(s)",
                width: "auto",
                accessor: (a: TrainingAttestation) => { 
                    return a.certifications?.map(_=>_.certificationName).join(", ")
                }
            },
            {
                Header: "Completed Date",
                width: "auto",
                accessor: (a: TrainingAttestation) => { 
                    return a.completedDate ? getDateWithOffset(a.completedDate).toLocaleDateString() : ""
                }
            },
            {
                Header: "Patient Safety",
                width: "auto",
                accessor: (a: TrainingAttestation) => {
                    return ( a.isPatientSafetyCompleted ? "Yes" : "No" )
                }
            },
            {
                Header: "Attested Date",
                width: "auto",
                accessor: (a: TrainingAttestation) => { 
                    return a.attestedDate ? getDateWithOffset(a.attestedDate).toLocaleDateString() : ""
                }
            },
            {
                Header: "Attested By",
                width: "auto",
                accessor: (a: TrainingAttestation) => { 
                    return a.firstName? a.firstName + " " +a.lastName : a.attestedBy
                }
            },
         ],
        [props.residency.trainingAttestations.filter(_ => _.isAttestedComplete)]
    );

    return (
        <>
            <div className="d-flex justify-content-between">
                <h5 className="fw-bolder ml-2 mt-1 mb-4 text-primary">Attestations of Completed Residency Training</h5>
            </div>
            <PreCertTable columns={trainingAttestationColumns} data={props.residency.trainingAttestations.filter(_ => _.isAttestedComplete)} />
        </>
    );
}